module.exports = __webpack_public_path__ + "static/media/icon_minimize.dc98145f.svg";